import axios from 'axios'
import ParamUtils from '@/core/utils/ParamUtils'

const urlBaseComprasDiretas = '/compra-direta/api/v1/comprador/compras-diretas/'
const urlBaseComprador = '/compra-direta/api/v1/comprador/'
const urlBaseAutoridadeSuperior = '/compra-direta/api/v1/comprador/autoridade-superior/compras-diretas/'

class CompradorComprasDiretasApiClient {

    async buscarConfiguracaoPrazoIncisos() {
        return await axios.get(`${urlBaseComprasDiretas}amparos-legais/configuracao/buscar`)
    }

    async removerConfiguracaoPrazoInciso(dados) {
        return await axios.put(`${urlBaseComprasDiretas}amparos-legais/configuracao/remover`, dados)
    }

    async buscarAmparosLegaisHierarquico(filtros) {
        const params = ParamUtils.objetoParaQueryParams(filtros)
        return await axios.get(`${urlBaseComprasDiretas}amparos-legais/configuracao/buscar-por-filtro${params}`)
    }

    async cadastrarConfiguracaoPrazoInciso(dados) {
        return await axios.put(`${urlBaseComprasDiretas}amparos-legais/configuracao/cadastrar`, dados)
    }

    async atualizarConfiguracaoPrazoInciso(dados) {
        return await axios.put(`${urlBaseComprasDiretas}amparos-legais/configuracao/atualizar`, dados)
    }

    async adicionarAnexoDadosGerais(compraDiretaId, anexo) {
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/anexos`, anexo)
    }

    async adjudicarFornecedor(compraDiretaId, itens) {
        return await axios.put(`${urlBaseAutoridadeSuperior}${compraDiretaId}/resultado/adjudicar`, { itens })
    }

    async verificarSaldoSubelemento(compraDiretaId, rankingId, tipoItemOuLote){
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/resultado/item-ou-lote/${rankingId}/verificar-saldo?tipoItemOuLote=${tipoItemOuLote}`)
    }

    async declararFornecedorVencedor(compraDiretaId, rankingId, tipoItemOuLote) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/resultado/item-ou-lote/${rankingId}/declarar-vencedor`, {tipoItemOuLote: tipoItemOuLote})
    }

    async enviarParaHomologacao(compraDiretaId, rankingId, tipoItemOuLote) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/resultado/item-ou-lote/${rankingId}/enviar-para-homologacao`, {tipoItemOuLote: tipoItemOuLote})
    }

    async cancelarEnvioParaHomologacao(compraDiretaId, rankingId, tipo) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/resultado/item-ou-lote/${rankingId}/cancelar-envio-para-homologacao?tipo=${tipo}`)
    }

    async incluirPropostaManual(compraDiretaId) {
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/resultado/incluir-proposta-manual`)
    }

    async alterarExclusividadeItem(compraDiretaId, itemId, novoValor) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/itens/${itemId}`, {porteExclusivo: novoValor})
    }

    async alterarExclusividadeLote(compraDiretaId, loteId, novoValor) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/lotes/${loteId}`, {porteExclusivo: novoValor})
    }

    async alterarSituacaoDeItemELote(compraDiretaId, dados) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/itens/alterar-situacao`, dados)
    }

    async suspenderCompraDireta(compraDiretaId, dados){
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/suspender`, dados)
    }

    async retomarCompraDireta(compraDiretaId, dados){
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/retomar-suspensao`, dados)
    }

    async atualizarAnaliseDeDocumentoSelecionado(compraDiretaId, fornecedorId, documentoSolicitadoId, documentoApresentadoId, situacao, motivoReenvio) {
        return await axios
            .post(`${urlBaseComprasDiretas}${compraDiretaId}/fornecedores/${fornecedorId}/documentos/${documentoSolicitadoId}?situacao=${situacao}`,
                {motivoReenvio: motivoReenvio, documentoApresentadoId: documentoApresentadoId})
    }

    async solicitarEnvioDeDocumentoSelecionado(compraDiretaId, fornecedorId, documentoSolicitadoId, mensagem) {
        return await axios
            .post(`${urlBaseComprasDiretas}${compraDiretaId}/fornecedores/${fornecedorId}/documentos/${documentoSolicitadoId}/solicitar-envio`,
                {mensagem: mensagem})
    }

    async solicitarAssinaturaDoDocumentoSelecionado(compraDiretaId, fornecedorId, documentoId, tipoDocumento, descricaoDocumento,
        documentoVirtualizadoId, renovarAssinatura, conviteId) {
        const params = new URLSearchParams({
            tipoDocumento,
            descricaoDocumento,
            documentoVirtualizadoId,
            renovarAssinatura
        })
        if (conviteId !== null) {
            params.append('conviteId', conviteId)
        }
        return await axios.put(
            `${urlBaseComprasDiretas}${compraDiretaId}/fornecedores/${fornecedorId}/documentos/${documentoId}/solicitar-assinatura?${params}`
        )
    }

    async atualizarTipoAnexoDadosGerais(compraDiretaId, anexo) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/anexos/${anexo.id}`, anexo)
    }

    async baixarHistoricoDeLances(compraDiretaId) {
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/relatorio-lances`,
            {
                responseType: 'arraybuffer'
            })
    }

    async baixarResultadoItensLotes(compraDiretaId) {
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/relatorio-resultados`,
            {
                responseType: 'arraybuffer'
            })
    }

    async buscarComprasDiretasEmAndamento(filtros, paginacao) {
        return await axios.get(`${urlBaseComprasDiretas}` +
            `?${ParamUtils.ObjectsToParams([paginacao, filtros])}`)
    }

    async buscarComprasDiretasEmElaboracao(filtros, paginacao) {
        return await axios.get(`${urlBaseComprasDiretas}` +
            `?${ParamUtils.ObjectsToParams([paginacao, filtros])}`)
    }

    async buscarComprasDiretasEncerradas(filtros, paginacao) {
        return await axios.get(`${urlBaseComprasDiretas}` +
            `?${ParamUtils.ObjectsToParams([paginacao, filtros])}`)
    }

    async buscarDadosDeAcompanhamento(compraDiretaId) {
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/acompanhamento-lances`)
    }

    async buscarDadosGerais(compraDiretaId) {
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}`)
    }

    async buscarDocumentosAnalise(compraDiretaId, fornecedorId, itemLoteId, itemLoteTipo) {
        const paramObj = {
            itemLoteId,
            itemLoteTipo
        }
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/fornecedores/` +
            `${fornecedorId}/analise/documentos?` + ParamUtils.ObjectsToParams([paramObj]))
    }

    async buscarDocumentosVirtualizados(compraDiretaId) {
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/analise/documentos`)
    }

    async buscarItensELotes(compraDiretaId) {
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/itens`)
    }

    async buscarResultadoItensELotes(compraDiretaId, page, rowsPerPage) {
        let url = `${urlBaseComprasDiretas}${compraDiretaId}/resultado?page=${page}&rowsPerPage=${rowsPerPage}`
        return await axios.get(url)
    }

    async buscarResumoCompraDireta(compraDiretaId) {
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/resumo`)
    }

    async buscarResumoItemELote(compraDiretaId) {
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/itens/resumo`)
    }

    async buscarTodasComprasDiretas(filtros, paginacao) {
        return await axios.get(`${urlBaseComprasDiretas}` +
            `?${ParamUtils.ObjectsToParams([paginacao, filtros])}`)
    }

    async desclassificarFornecedor(compraDiretaId, rankingId, tipoItemOuLote, motivo) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/resultado/item-ou-lote/${rankingId}/desclassificar`, {
            tipoItemOuLote: tipoItemOuLote,
            motivo: motivo
        })
    }

    async inabilitarFornecedor(compraDiretaId, rankingId, tipoItemOuLote, motivo, fornecedorId, inabilitarTodos) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/resultado/item-ou-lote/${rankingId}/inabilitar`, {
            tipoItemOuLote: tipoItemOuLote,
            motivo: motivo,
            fornecedorId: fornecedorId,
            inabilitarTodos: inabilitarTodos
        })
    }

    async desempatarFornecedores(compraDiretaId, itemOuLoteId, requestData) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/resultado/item-ou-lote/${itemOuLoteId}/desempatar`, requestData)
    }

    async desempatarFornecedoresEtapaFechada(compraDiretaId, itemOuLoteId, tipo) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/resultado/item-ou-lote/${itemOuLoteId}/lances-desempate?tipo=${tipo}`)
    }

    async desempatarFornecedoresManualmente(compraDiretaId, itemOuLoteId, requestData) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/resultado/item-ou-lote/${itemOuLoteId}/desempatar-manualmente`, requestData)
    }

    async excluir(compraDiretaId, removerNaOrigem) {
        let url = `${urlBaseComprasDiretas}${compraDiretaId}`
        if (typeof removerNaOrigem !== 'undefined') {
            url = `${url}?removerNaOrigem=${removerNaOrigem}`
        }
        return await axios.delete(url)
    }

    async excluirAnexoDadosGerais(compraDiretaId, anexoId) {
        return await axios.delete(`${urlBaseComprasDiretas}${compraDiretaId}/anexos/${anexoId}`)
    }

    async atualizarSituacaoAnexoCompraDireta(payload) {
        return await axios.put(`${urlBaseComprasDiretas}anexo/atualizar`, payload)
    }

    async buscarOrgaosDisponiveis(compraDiretaId) {
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/dominios/disponiveis`)
    }

    async excluirItem(compraDiretaId, itemId) {
        return await axios.delete(`${urlBaseComprasDiretas}${compraDiretaId}/itens/${itemId}`)
    }

    async excluirLote(compraDiretaId, loteId) {
        return await axios.delete(`${urlBaseComprasDiretas}${compraDiretaId}/lotes/${loteId}`)
    }

    async exportar(compraDiretaId) {
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/exportar-resultado`)
    }

    async exportarComprasPreparacao(compraDiretaId) {
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/exportar-resultado-preparacao`)
    }

    async exportarArquivo(compraDiretaId, tipoExportacao) {
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/exportar-resultado-arquivo?tipoExportacao=${tipoExportacao}`,
            {
                responseType: 'arraybuffer'
            })
    }

    async exportarMaisBrasil(compraDiretaId, situacao){
        const params = {situacaoMaisBrasil: situacao}
        return await axios.post(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/exportar-mais-brasil`+
            `?${ParamUtils.ObjectsToParams([params])}`)
    }

    async relatorioMaisBrasil(compraDiretaId){
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/relatorio-mais-brasil`,
            {
                responseType: 'arraybuffer'
            }
        )
    }

    async importarCompras(compraDiretaId, arquivo) {
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/itens/importar-txt`, arquivo)
    }

    async importarPlanilha(compraDiretaId, arquivo) {
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/itens/importar-planilha`, arquivo)
    }

    async negociarItemOuLote(compraDiretaId, rankingId, tipoItemOuLote, mensagem) {
        return axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/resultado/item-ou-lote/${rankingId}/negociar`,
            {
                tipoItemOuLote: tipoItemOuLote,
                mensagem: mensagem
            }
        )
    }

    async salvarDadosGerais(dadosGerais) {
        return await axios.put(`${urlBaseComprasDiretas}${dadosGerais.id}`, dadosGerais)
    }

    async salvarItensELotes(itensELotes, compraDiretaId) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/itens`, itensELotes)
    }

    async buscarAutocompleteImportarCompraDireta(numeroProcesso) {
        return await axios.get(`${urlBaseComprasDiretas}disponibilidade-importacao?conteudo=${numeroProcesso}`)
    }

    async publicar(id) {
        return await axios.put(`${urlBaseComprasDiretas}${id}/publicar`)
    }

    async criarCompraDireta(processo) {
        return await axios.post(`${urlBaseComprasDiretas}criar?`+
            ParamUtils.ObjectsToParams([{processo: processo}]))
    }

    async salvarDadosGeraisNovaCompra(dadosGerais) {
        return await axios.put(`${urlBaseComprasDiretas}nova/${dadosGerais.id}/atualizar`, dadosGerais)
    }

    async reclassificarFornecedor(compraDiretaId, rankingId, tipoItemOuLote, motivo) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/resultado/item-ou-lote/${rankingId}/reclassificar`, {
            tipoItemOuLote: tipoItemOuLote,
            motivo: motivo
        })
    }

    async habilitarFornecedor(compraDiretaId, tipoItemOuLote, rankingId, motivo, fornecedorId, habilitarTodos) {
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/resultado/item-ou-lote/${rankingId}/habilitar`, {
            tipoItemOuLote: tipoItemOuLote,
            motivo: motivo,
            fornecedorId: fornecedorId,
            habilitarTodos: habilitarTodos
        })
    }

    async cancelarAdjudicacao(compraDiretaId, tipoItemOuLote, rankingId, motivo, pessoaId, processo){

        const params = {
            tipo: tipoItemOuLote,
            processo: processo
        }

        return await axios.put(`${urlBaseAutoridadeSuperior}${compraDiretaId}/fornecedores/` +
            `${pessoaId}/rankings/${rankingId}/cancelar-adjudicacao/?${ParamUtils.ObjectsToParams([params])}`,
        {motivo: motivo})
    }

    async cancelarDeclaracaoVencedor(compraDiretaId, tipoItemOuLote, rankingId, motivo, pessoaId, processo){

        const params = {
            tipo: tipoItemOuLote,
            processo: processo
        }

        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/fornecedores/` +
            `${pessoaId}/rankings/${rankingId}/cancelar-declaracao-vencedor/?${ParamUtils.ObjectsToParams([params])}`,
        {motivo: motivo})
    }

    async baixarDocumentoCompraDireta(documentoVirtualizadoId, opcaoDownloadVirtualizacao, nomeArquivo, compraDiretaId, noProcessoDigital, uri){
        const paramObj = {
            documentoVirtualizadoId:documentoVirtualizadoId,
            nomeArquivo:nomeArquivo,
            opcaoDownloadVirtualizacao:opcaoDownloadVirtualizacao,
            uri:uri
        }
        return await axios.get(
            `/compra-direta/api/v1/compras-direta/${compraDiretaId}/documentos-virtualizados/download?noProcessoDigital=${noProcessoDigital}&` +
            ParamUtils.ObjectsToParams([paramObj]),
            {
                responseType: 'arraybuffer'
            }
        )
    }

    async juntarDocumentoCompraDireta(compraDiretaId, documentoId, documentoVirtualizadoId, tipoDocumento, pessoaId){
        const paramObj = {documentoVirtualizadoId, tipoDocumento, pessoaId}
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/documentos/${documentoId}/juntar?`+
            ParamUtils.ObjectsToParams([paramObj])
        )
    }

    async baixarDocumentoVirtualizado(documentoVirtualizadoId, opcaoDownloadVirtualizacao, nomeArquivo, compraDiretaId, uri, noProcessoDigital){
        const paramObj = {
            documentoVirtualizadoId:documentoVirtualizadoId,
            nomeArquivo:nomeArquivo,
            opcaoDownloadVirtualizacao:opcaoDownloadVirtualizacao,
            uri:uri
        }
        return await axios.get(`/compra-direta/api/v1/compras-direta/${compraDiretaId}/documentos-virtualizados/download` +
            `?noProcessoDigital=${noProcessoDigital}&` + ParamUtils.ObjectsToParams([paramObj]),
        {
            responseType: 'arraybuffer'
        }
        )
    }

    async baixarDocumentoVirtualizadoZipado(dadosDocumentos){
        const { compraDiretaId } = dadosDocumentos[0]

        return await axios.post(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/documentos/zipado`,
            { documentos: dadosDocumentos },
            { responseType: 'arraybuffer' }
        )
    }

    async juntarDocumentosEmLote(dadosDocumentos){
        const { compraDiretaId } = dadosDocumentos[0]

        return await axios.post(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/documentos/juntar-lote`,
            { documentos: dadosDocumentos }
        )
    }

    async baixarDocumentoEndPoint(nomeArquivo, compraDiretaId){
        const params = {
            compraDiretaId: compraDiretaId,
        }

        let endPoint = '/compra-direta/api/v1/virtualizacoes/lista-convidados/baixar?'+ ParamUtils.ObjectsToParams([params])

        if(nomeArquivo === 'Capa_compra_direta.pdf')
            endPoint = '/compra-direta/api/public/v1/virtualizacoes/capa-compra-direta/baixar?'+ ParamUtils.ObjectsToParams([params])

        return await axios.get(endPoint, { responseType: 'arraybuffer' })
    }

    async virtualizarDocumentoCompraDireta(compraDiretaId, tipoDocumento){
        const paramObj = {
            compraDiretaId,
            tipoDocumento
        }
        return await axios.post(`/compra-direta/api/v1/compras-diretas/${compraDiretaId}/documento/virtualizar`, paramObj)
    }

    async buscarInformacoesSistema(){
        let source = axios.CancelToken.source()
        setTimeout(() => {
            source.cancel()
        }, 10000)

        return await axios.get('/compra-direta/api/v1/comprador/informacoes-sistema/status',
            {cancelToken: source.token}
        )
    }

    async encerrarCompraDireta(compraDiretaId) {
        return axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/encerrar`)
    }

    async despublicarCompraDireta(compraDiretaId, motivo) {
        return axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/despublicar`, {compraDiretaId, motivo})
    }

    async prorrogarCompraDireta(compraDiretaId, motivo, dataHoraAtualizada) {
        return axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/prorrogar`, {compraDiretaId, motivo, dataHoraAtualizada})
    }

    async buscarEventosPosPublicacao(compraDiretaId) {
        return axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/eventospospublicacao`)
    }

    async buscarRequisicoesPorSistema(sistema, paginacao, filtros) {
        return await axios.get(`/compra-direta/api/v1/comprador/requisicoes-http/${sistema}/todas` +
            `?${ParamUtils.ObjectsToParams([paginacao, filtros])}`)
    }

    async buscarRequestBodyDaRequisicao(requisicaoId) {
        return await axios.get(`/compra-direta/api/v1/comprador/requisicoes-http/${requisicaoId}/requestBody`)
    }

    async atualizarRequisicaoHttp(requisicao){
        return axios.put(`/compra-direta/api/v1/comprador/requisicoes-http/${requisicao.id}`, requisicao)
    }

    async reenviarRequisicaoHttp(requisicaoId){
        return axios.post(`/compra-direta/api/v1/comprador/requisicoes-http/${requisicaoId}/reenviar`)
    }

    async reverterSituacaoItemLote(compraDiretaId, itemOuLoteId, isLote) {
        return axios.put(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/desfazer-cancelamento?`+
            `id=${itemOuLoteId}&isLote=${isLote}`)
    }

    async baixarTodosDocumentosApresentados(data) {
        return await axios.get(`/compra-direta/api/v1/comprador/arquivos/baixar-todos?${ParamUtils.ObjectToParams(data)}`,
            {
                responseType: 'arraybuffer'
            })
    }

    async baixarDocumentoFornecedor(url){
        return await axios.get(url,
            {
                responseType: 'arraybuffer'
            })
    }

    async baixarRelatorioPropostasItemLote(compraDiretaId, id, tipo) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/itens-lotes/${id}/propostas?tipo=${tipo}`,
            {
                responseType: 'arraybuffer'
            })
    }

    async enviarSolicitacaoReajusteItemLote(dados) {
        const {compraDiretaId, itemOuLoteId} = dados
        return await axios.post(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/itens-lotes/${itemOuLoteId}/solicitar-readequacao`, dados)
    }

    async cancelarNegociacao(compraDiretaId, itemOuLoteId, tipoItemOuLote, negociacaoId, motivo) {
        // eslint-disable-next-line max-len
        return await axios.delete(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/resultado/item-ou-lote/${itemOuLoteId}/negociacao/${negociacaoId}/cancelar?tipo=${tipoItemOuLote}&motivo=${motivo}`)
    }

    async buscarNotificacoesComprador(input){
        return await axios.get(`/compra-direta/api/v1/comprador/notificacoes?${ParamUtils.ObjectToParams(input)}`)
    }

    async contarNotificacoesNaoLidas(input) {
        return await axios.get(`/compra-direta/api/v1/comprador/notificacoes/contar-nao-lidas?${ParamUtils.ObjectToParams(input)}`)
    }

    async buscarNotificacoesChatComprador(input){
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/chat/notificacoes?${ParamUtils.ObjectToParams(input)}`)
    }

    async buscarUmaUnicaNotifificao(notificacaoId){
        return await axios.get(`/compra-direta/api/v1/notificacoes/${notificacaoId}`)
    }

    async buscarConversacaoChatMensagens(compraDiretaId, dados) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/chat/mensagens?${ParamUtils.ObjectsToParams([dados])}`)
    }

    async iniciarAssinaturaDocumentosEmLote(compraDiretaId, usuarioId, documentos) {
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/documentos/iniciar-assinatura-em-lote?usuarioId=${usuarioId}`,
            { documentos: documentos }
        )
    }

    async finalizarAssinaturaDocumentosEmLote(dadosAssinatura) {
        const {compraDiretaId, ...dados} = dadosAssinatura
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/documentos/finalizar-assinatura-em-lote`, dados)
    }

    async buscarComprasDiretasHomologacao() {
        return await axios.get(`${urlBaseAutoridadeSuperior}em-homologacao`)
    }

    async devolverItemLote(dados) {
        const { compraDiretaId, rankingId, ...requestInput } = dados
        return await axios.put(`${urlBaseAutoridadeSuperior}${compraDiretaId}/resultado/item-ou-lote/${rankingId}/devolver`, requestInput)
    }

    async baixarTermoHomologacao(compraDiretaId) {
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/baixar-termo-homologacao`,
            {
                responseType: 'arraybuffer'
            })
    }

    async removerRequisicaoComErro(id, data) {
        return await axios.delete(`${urlBaseComprador}requisicoes-http/${id}?${ParamUtils.ObjectToParams(data)}`)
    }

    async enviarDispensaEsfinge(compraDiretaId) {
        const requestInput = { compraDiretaId }
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/enviar-dispensa-esfinge`, requestInput)
    }

    async alterarDispensaEsfinge(compraDiretaId) {
        const requestInput = { compraDiretaId }
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/alterar-dispensa-esfinge`, requestInput)
    }

    async buscarDispensaEsfinge(compraDiretaId) {
        const requestInput = { compraDiretaId }
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/buscar-dispensa-esfinge`, requestInput)
    }

    async cancelarDispensaEsfinge(compraDiretaId) {
        const requestInput = { compraDiretaId }
        return await axios.delete(`${urlBaseComprasDiretas}${compraDiretaId}/cancelar-dispensa-esfinge`, requestInput)
    }

    async enviarOcorrenciaEsfinge(dados) {
        const { compraDiretaId } = dados
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/enviar-ocorrencia-esfinge`, dados)
    }

    async alterarOcorrenciaEsfinge(dados) {
        const { compraDiretaId } = dados
        return await axios.put(`${urlBaseComprasDiretas}${compraDiretaId}/alterar-ocorrencia-esfinge`, dados)
    }

    async buscarOcorrenciaEsfinge(numeroProtocolo) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/buscar-ocorrencia-esfinge?numeroProtocolo=${encodeURIComponent(numeroProtocolo)}`)
    }

    async buscarListagemPaginadaProtocolosOcorrencia({ compraDiretaId, protocolo, situacoes, page, rowsPerPage, sortBy, sort }) {
        const params = new URLSearchParams()
        if (protocolo) params.append('protocolo', protocolo)
        if (situacoes && situacoes.length > 0) {
            situacoes.forEach(situacao => params.append('situacoes', situacao))
        }
        if (page !== undefined) params.append('page', page)
        if (rowsPerPage !== undefined) params.append('rowsPerPage', rowsPerPage)
        if (sortBy) params.append('sortBy', sortBy)
        if (sort) params.append('sort', sort)

        const queryString = params.toString() ? `?${params.toString()}` : ''
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/itens-ocorrencia${queryString}`)
    }

    async cancelarOcorrenciaEsfinge({ compraDiretaId, numeroProtocolo, itemLoteCompraDiretaId, identificador }) {
        const requestInput = { numeroProtocolo, itemLoteCompraDiretaId, identificador }
        return await axios.delete(`${urlBaseComprasDiretas}${compraDiretaId}/cancelar-ocorrencia-esfinge`, { data: requestInput })
    }

    async desentranharDocumentoVirtualizado({ compraDiretaId, documentoId, tipo, documentoVirtualizadoId, ...body }) {
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/documentos/${documentoId}/desentranhar`+
            `?tipo=${tipo}&documentoVirtualizadoId=${documentoVirtualizadoId}`, body)
    }

    async desentranharDocumentoVirtualizadoV2({ compraDiretaId, documentoId, tipoDocumento, ...body }) {
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/documentos/gerar-termo-desentranhamento`, {
            tipoDocumento,
            documentoId,
            ...body
        })
    }

    async buscarDocumentoEditorTextoPorId(idDocumento) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/documentos/editor-texto/${idDocumento}`)
    }

    async sincronizarDocumentoEditorTexto(idDocumentoEditorTexto) {
        return await axios.post(`/compra-direta/api/v1/comprador/desentranhamento/documento-editor-texto/${idDocumentoEditorTexto}/sincronizar`)
    }

    async buscarDocumentoPorReferenciaDesentranhamento(idReferenciaDesentranhado) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/0/documentos/0/infos-desentranhamento/documento-referencia/${idReferenciaDesentranhado}`)
    }

    async buscarInfosDocDesentranhamento({ compraDiretaId, documentoId, tipo, documentoVirtualizadoId}) {
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/documentos/${documentoId}/infos-desentranhamento`+
        `?tipo=${tipo}&documentoVirtualizadoId=${documentoVirtualizadoId}`)
    }

    async reordenarDocumentoVirtualizado({ compraDiretaId, documentoId, tipo, documentoVirtualizadoId, ...body }) {
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/documentos/${documentoId}/reordenar`+
            `?tipo=${tipo}&documentoVirtualizadoId=${documentoVirtualizadoId}`, body)
    }

    async cancelarDocumentoVirtualizado({ compraDiretaId, documentoId, ...body }){
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/documentos/${documentoId}/cancelamento`, body)
    }

    async buscarSituacaoEdocsDocumentos({ compraDiretaId }) {
        return await axios.get(`${urlBaseComprasDiretas}${compraDiretaId}/buscar-edocs`)
    }

    async acessarEdocs({ processoId }) {
        return await axios.get(`/flowbee/api/integracoes/e-docs/processos/${processoId}/url-acesso`)
    }

    async buscarListagemPaginada(filtros, paginacao) {
        return await axios.get(`/compra-direta/api/v1/comprador/fornecedores?${ParamUtils.ObjectsToParams([paginacao, filtros])}`)
    }

    async validarParaProposta(compraDiretaId, fornecedorId) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/termo/validar-fornecedor?fornecedorId=${fornecedorId}`)
    }

    async buscarTermos(compraDiretaId, fornecedorId) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/buscar-termo?fornecedorId=${fornecedorId}`)
    }

    async criarTermos(compraDiretaId, fornecedorId) {
        return await axios.post(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/termo`,
            { fornecedorId }
        )
    }

    async salvarTermos(compraDiretaId, propostaId, termos) {
        return await axios.put(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/propostas/${propostaId}/termo`, termos)
    }

    async buscarResumoProposta(compraDiretaId, propostaId, fornecedorId) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/propostas/resumo-compra-direta?propostaId=${propostaId}&fornecedorId=${fornecedorId}`)
    }

    async buscarDetalhesComprador(compraDiretaId) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/detalhes`)
    }

    async buscarItensELotesDaProposta(compraDiretaId, fornecedorId) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/propostas?fornecedorId=${fornecedorId}`)
    }

    async salvarValorIndividual(itemProposta) {
        return await axios.put(`/compra-direta/api/v1/comprador/item-proposta/${itemProposta.propostaItemId}`, itemProposta)
    }

    async buscarDocumentosSolicitados(compraDiretaId, fornecedorId) {
        return await axios.get(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/fornecedores/documentos?fornecedorId=${fornecedorId}`)
    }

    async adicionarAnexoDocumentoSolicitado(compraDiretaId, arquivo, fornecedorId) {
        const uri = arquivo.anexo.uri
        const documentoSolicitadoId = arquivo.documentoSolicitadoId
        return await axios.post(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/fornecedores/documentos/${documentoSolicitadoId}
        ?uri=${uri}&fornecedorId=${fornecedorId}`)
    }

    async removerDocumentoApresentado(compraDiretaId, documentoApresentadoId, fornecedorId) {
        return await axios.delete(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/fornecedores/documentos-apresentados/${documentoApresentadoId}`,
            {
                data: { fornecedorId }
            })
    }

    async atualizarLotePropostaMaiorDesconto(lotePropostaId, lote){
        return await axios.put(`/compra-direta/api/v1/comprador/lote-proposta/${lotePropostaId}`, lote)
    }

    async enviarProposta(compraDiretaId, propostaId, validarMargem, fornecedorId) {
        return await axios.post(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/propostas/${propostaId}
        ?validarMargem=${validarMargem}&fornecedorId=${fornecedorId}`)
    }

    async rankearPropostas(compraDiretaId) {
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/rankear`)
    }

    async inserirReajustePropostas(compraDiretaId) {
        return await axios.post(`${urlBaseComprasDiretas}${compraDiretaId}/reajuste-proposta`)
    }

    async enviarDocumentosAnalise(compraDiretaId, fornecedorId) {
        return await axios.post(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/fornecedores/documentos/enviar`,
            { fornecedorId })
    }

    async removerProposta(compraDiretaId, propostaId, fornecedorId) {
        return await axios.delete(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/propostas/${propostaId}`,
            {
                data: { fornecedorId }
            })
    }

    async enviarReajusteLote(compraDiretaId, loteCompraDiretaId, fornecedorId) {
        return await axios.put(`/compra-direta/api/v1/comprador/compras-diretas/${compraDiretaId}/reajuste-lote-proposta/${loteCompraDiretaId}`,
            { fornecedorId })
    }
}

export default new CompradorComprasDiretasApiClient()
